<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-a-hellenistic-fire">
<h1></h1>
<h1>Part A:<br/> Hellenistic Fire</h1>
<p><em>Understand that you are a god—the rule of reason and freewill over your mind and body—is like the rule of God himself over the physical universe.</em></p>
<p>(Cicero, <em>de re publica</em>, Bk. VI Somnium Scipionis)</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?63c06a24